import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { finalChecks } from '../../data/pathway';
import { MOCKUP_URL } from '../../data/offer';
export function FinalCta() {
  return <>
      <section className="bg-panel py-16 sm:py-24" aria-labelledby="final-title" data-id="element-161" data-mp="1nn5a46fbpo9h">
        <div className="mx-auto max-w-4xl px-5" data-id="element-162" data-mp="1slzuhcsxvkvp">
          <div className="text-center" data-id="element-163" data-mp="1eo1s75rw7ewk">
            <p className="font-display text-lg font-bold uppercase tracking-[0.06em] text-volt sm:text-xl" data-id="element-164" data-mp="1en06869c9802">
              Stop restarting your troubleshooting process from scratch
            </p>
            <h2 id="final-title" className="mt-2 text-balance font-display text-[42px] font-extrabold uppercase leading-[0.95] text-white sm:text-6xl" data-id="element-165" data-mp="14ryh3af2c5xh">
              Build a more structured HVAC electrical investigation workflow
            </h2>
            <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-mist" data-id="element-166" data-mp="342znybr0w5rb">
              Every electrical service call can involve different symptoms, circuits, equipment configurations, and
              technical requirements. But the way you organize your investigation doesn’t have to change completely
              every time.
            </p>
          </div>

          <ul className="mx-auto mt-10 grid max-w-2xl gap-3 sm:grid-cols-2" data-id="element-167" data-mp="b39go0u4iiw3">
            {finalChecks.map(c => <li key={c} className="flex items-center gap-3 rounded-xl bg-ink px-4 py-3 text-[16px] font-medium text-white ring-1 ring-line" data-id="element-168" data-mp="3ffdaxwv95ova">
                <CheckIcon className="h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-169" data-mp="3ahv9ssnh8dxu" />
                {c}
              </li>)}
          </ul>

          <div className="mx-auto mt-10 max-w-2xl space-y-2 text-center text-lg text-mist" data-id="element-170" data-mp="3jgqge5ufnq1o">
            <p data-id="element-171" data-mp="13pksk7n6k687">Instead of scattered observations, work toward a complete, organized troubleshooting record.</p>
            <p data-id="element-172" data-mp="yrsokf99gtnn">Instead of relying on memory, use practical worksheets and decision checkpoints.</p>
            <p data-id="element-173" data-mp="3sjscyu7g143n">Instead of finishing with disconnected notes, create a structured report.</p>
          </div>

          <div className="mx-auto mt-12 max-w-xl rounded-[28px] border-2 border-amber bg-ink p-6 text-center sm:p-8" data-id="element-174" data-mp="1bmy03pkxbhq">
            <p className="font-display text-2xl font-extrabold uppercase leading-tight text-white" data-id="element-175" data-mp="5et1x4p7yql1">
              Your next HVAC electrical investigation deserves a clear plan.
            </p>
            <img src={MOCKUP_URL} alt="HVAC Electrical Troubleshooting Blueprint bundle" className="mx-auto mt-5 w-full max-w-sm rounded-2xl bg-white p-2" data-id="element-176" data-mp="39tsr0g6wg54g" />
            <p className="mt-5 font-display text-lg font-bold uppercase text-mist" data-id="element-177" data-mp="3itfur8n3pn0o">6 Practical Volumes + 5 Professional Bonuses</p>
            <p className="font-display text-7xl font-extrabold leading-none text-amber" data-id="element-178" data-mp="3nkxvbvl7pll4">
              $27<span className="ml-1 align-top text-xl text-white" data-id="element-179" data-mp="2q3h2z5hivbsb">USD</span>
            </p>
            <div className="mt-6" data-id="element-180" data-mp="2v2tpfp4hegud">
              <CtaButton label="Yes! Build my 5-step troubleshooting workflow" data-id="element-181" data-mp="2v1scff3wnka0" />
            </div>
            <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-sm font-semibold text-mist" data-id="element-182" data-mp="2njkh7z7poo6w">
              <li className="flex items-center gap-1.5" data-id="element-183" data-mp="2iiwp1a7qy1b3">
                <ZapIcon className="h-4 w-4 text-amber" aria-hidden="true" data-id="element-184" data-mp="2dkv7wutvsc29" /> Instant access
              </li>
              <li className="flex items-center gap-1.5" data-id="element-185" data-mp="29jjcu9s8mymo">
                <LockIcon className="h-4 w-4 text-ok" aria-hidden="true" data-id="element-186" data-mp="24kydeckt8iza" /> Secure one-time payment
              </li>
              <li className="flex items-center gap-1.5" data-id="element-187" data-mp="1zu880zcdwg4l">
                <ShieldCheckIcon className="h-4 w-4 text-volt" aria-hidden="true" data-id="element-188" data-mp="1zsf2xohf63yp" /> 7-day guarantee
              </li>
            </ul>
          </div>

          <p className="mt-12 text-center font-display text-2xl font-bold uppercase leading-tight text-white sm:text-3xl" data-id="element-189" data-mp="1pxdaojruklrw">
            Organize the fault. Map the circuit. <span className="text-volt" data-id="element-190" data-mp="1gvnj9dxytmu4">Verify the evidence. Document the result.</span>
          </p>
        </div>
      </section>

      <footer className="bg-ink px-5 pb-32 pt-10" data-id="element-191" data-mp="3gxn23ao4dc5s">
        <div className="mx-auto max-w-3xl text-center" data-id="element-192" data-mp="3gzzsmc7y0uug">
          <p className="font-display text-xl font-bold uppercase text-volt" data-id="element-193" data-mp="3kyfeudw79z6t">HVAC Electrical Fault Pathway™</p>
          <p className="mt-4 text-xs leading-relaxed text-mist/80" data-id="element-194" data-mp="377amlwv5w96i">
            Professional educational and workflow resource. For qualified personnel only. Always follow applicable
            electrical codes, OSHA requirements where applicable, NFPA 70E or other relevant workplace electrical safety
            standards, manufacturer documentation, and employer-approved procedures. Never bypass protective devices or
            perform unauthorized energized work.
          </p>
          <p className="mt-4 text-xs text-mist/60" data-id="element-195" data-mp="2t9c90too0gs2">© {new Date().getFullYear()} HVAC Electrical Troubleshooting Blueprint™</p>
        </div>
      </footer>
    </>;
}